import React, { useEffect, useRef } from 'react';

function useClickOutside<T extends HTMLElement>(
  callback: () => void
): React.RefObject<T> {
  const ref = useRef<T>(null);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callback();
      }
    };
    // capture phase so an ancestor calling stopPropagation() during bubbling
    // (e.g. Popup's backdrop-click guard) can't block outside-click detection.
    document.addEventListener('click', handleClickOutside, true);

    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, [callback]);

  return ref;
}

export default useClickOutside;
